import assign from 'object-assign';
import { EventEmitter } from 'events';

import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import User from './entities/user';
import UserCollection from './entities/user-collection';
import { sortBy} from 'lodash'

const user = new User();
const userCollection = new UserCollection();
let salesReps = [];

const CHANGE_EVENT = AdminConstants.collectionChangeEvents;

let customerList = {};

function setMarketsPreference(action) {
  console.log('updating store with these markets: ', action.markets);
  user.set('markets', action.markets);
}

const UserStore = assign({}, EventEmitter.prototype, {
  getAdminUsers() {
    return sortBy(userCollection.toJSON(), [function(o) { return o.email; }]);
  },
  getCustomerList() {
    return customerList;
  },
  getSalesReps() {
    return salesReps;
  },
  setSalesReps(reps) {
    salesReps =  sortBy(reps, [(reps) => { return reps.email; }]);
  },
  getMarketsPreference() {
    return user.has('markets') && user.get('markets').length > 0
    ? user.get('markets') : ['LAX'];
  },

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
});

UserStore.dispatchToken = AdminAppDispatcher.register((payload) => {
  const action = payload.action;

  const ActionTypes = AdminConstants.ActionTypes;
  switch (action.type) {
    case ActionTypes.USER_SET_MARKETS_PREFERENCE:
      setMarketsPreference(action);
      UserStore.emitChange();
      break;
    case ActionTypes.USER_RECEIVE_MARKETS_PREFERENCE:
      setMarketsPreference(action);
      UserStore.emitChange();
      break;
    case ActionTypes.RECEIVE_USERS_WITH_TARIFF:
      setMarketsPreference(action);
      UserStore.emitChange();
      break;
    case ActionTypes.RECEIVE_SALES_REPS:
      UserStore.setSalesReps(action.users);
      UserStore.emitChange();
      break;
    case ActionTypes.RECEIVE_ADMIN_USERS:
      userCollection.set(action.users);
      UserStore.emitChange();
      break;
    case ActionTypes.RECEIVE_ADMIN_USER:
      userCollection.add(action.user);
      UserStore.emitChange();
      break;
    case ActionTypes.RECEIVE_CUSTOMER_LIST:
      customerList = action.customers;
      UserStore.emitChange();
      break;
    default:
  }
});

export default UserStore;
